(function(){
    let el_tiles = document.querySelectorAll('.collection__product-add-cart-button');

    let el_header_cart_count = document.getElementById('cart-count-display');
    let el_cart_icon_container = document.getElementById('cart-count-widget-contaioner');
    let el_mobile_cart_count = document.getElementById('cart-count-mobile-display');
    let el_mobil_cart_icon_container = document.getElementById('cart-count-widget-mobile-contaioner');

    function get_cart_count() {
        let xhr = new XMLHttpRequest();
        let url = "/cart.js";
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                el_header_cart_count.innerHTML = d.item_count;
                el_mobile_cart_count.innerHTML = d.item_count;
                el_cart_icon_container.style['display'] = 'block';
                el_mobil_cart_icon_container.style['display'] = 'block';
            }
        };
        xhr.send();
    }

    function set_in_cart(variant_id, count) {
        let xhr = new XMLHttpRequest();
        let url = "/cart/update.js";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                get_cart_count();
            }
        };
        let data_o = {
            updates: {}
        };
        data_o.updates[variant_id] = count;
        let data = JSON.stringify(data_o);
        xhr.send(data);
    }

    function increment_in_cart(variant_id) {
        let xhr = new XMLHttpRequest();
        let url = "/cart.js";
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let d = JSON.parse(this.responseText);
                var count = 0;
                for (var i = 0; i < d.items.length; i++) {
                    if (d.items[i].variant_id == parseInt(variant_id)) {
                        count = d.items[i].quantity;
                    }
                }
                set_in_cart(variant_id, count + 1);
            }
        };
        xhr.send();
    }

    function button_clicked(e) {
        var variant_id = e.currentTarget.dataset.variant_id;
        increment_in_cart(variant_id);
        e.stopPropagation();
        e.preventDefault();
    }

    for(let i = 0; i < el_tiles.length; i++) {
        el_tiles[i].addEventListener('click', button_clicked);
    }
})();
